// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import HeaderDropdown from './HeaderDropdown'

function HeaderFrame({
  children,
  dropdownOptions,
  projectID,
  hasEditPermission,
  onShowCollabModal,
  showCollabModal
}) {
  return (<div style={{
    width:"100%",
    display:"flex",
    flexWrap:"nowrap",
    height: "35px",
    alignItems: "center"
  }}>
    <div style={{
      flexGrow:1,
      flexBasis: 0,
      overflow: "hidden",
    }}>
      {children}
    </div>

    <div
      style={{
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0}}
    >
      {dropdownOptions && <HeaderDropdown
        projectID={projectID}
        hasEditPermission={hasEditPermission}
        onShowCollabModal={onShowCollabModal}
        showCollabModal={showCollabModal}
      >
        {dropdownOptions}      
      </HeaderDropdown>}
    </div>
  </div>)
}

export default HeaderFrame;